import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region STAGE

function _Stage(props) {
    const data = props.data || {};
    const hasValue = data.Stage && !Utilities.isNullOrWhitespace(data.Stage.Name);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Stage = withLabelTokenParsing(_Stage, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Stage:
            if (data.Stage && !Utilities.isNullOrWhitespace(data.Stage.Name)) {
                replaceString = data.Stage.Name;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Stage:', token: Token.Stage }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Stage:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Stage}}`, token: Token.Stage }))
    }
};

// #endregion STAGE

export {
    Stage as Component,
    Tokens,
    TypeConfig
}